import { useState } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import CustomSelectSimple from "./CustomSelectSimple";
import CustomCalendarInput from "./CustomCalendarInput";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/Context";

const kategorijeAll = [
  "Mašine sa povećanim rizikom",
  "Ručni alat",
  "Transportna sredstva",
];
const masinePoKategoriji = {
  "Mašine sa povećanim rizikom": ["Viljuškar", "Dizalica", "Presa"],
  "Ručni alat": ["Bušilica", "Brusilica"],
  "Transportna sredstva": ["Kamion", "Kombi"],
};

const nowDate = new Date()
  .toLocaleDateString("sr-RS", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
  .replaceAll("/", ".")
  .slice(0, -1);

const natpis = { fontWeight: "bold", fontSize: "14px", marginBottom: "5px" };
const inputStyle = {
  fontSize: "14px",
  height: "40px",
  padding: "0 8px",
  width: "100%",
  boxSizing: "border-box",
};

function EvidencijeObrazac8Dodavanje({ setIsDodavanje, onRefresh }) {
  const [obrazac, setObrazac] = useState({
    kategorija: "",
    vrstaMasine: "",
    broj_nalaza: "",
    datum_pregleda: nowDate,
    napomena: "",
  });

  const { baseUrl, selectedMainEntity } = useGlobalContext();

  const handleChange = (newValue, field) => {
    setObrazac((prev) => {
      const updated = { ...prev, [field]: newValue };
      if (field === "kategorija") updated.vrstaMasine = "";
      return updated;
    });
  };

  const formatDateForApi = (dateStr) => {
    if (!dateStr) return null;
    const parts = dateStr.split(".");
    if (parts.length < 3) return null;
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  };

  const handleSacuvaj = async () => {
    try {
      const oprema_podaci = `${obrazac.kategorija}${obrazac.vrstaMasine ? " - " + obrazac.vrstaMasine : ""}`;
      const { data } = await axios.post(`${baseUrl}/evidencija8/create.php`, {
        company_id: selectedMainEntity.company_id,
        oprema_podaci,
        broj_nalaza: obrazac.broj_nalaza,
        datum_pregleda: formatDateForApi(obrazac.datum_pregleda),
        napomena: obrazac.napomena,
      });
      if (data.status === 200) {
        onRefresh();
        setIsDodavanje(false);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const isDisabledSacuvaj =
    !obrazac.kategorija || !obrazac.vrstaMasine || !obrazac.broj_nalaza;

  return (
    <div>
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-end" }}>
        <div style={{ width: "15vw" }}>
          <div style={natpis}>KATEGORIJA</div>
          <CustomSelectSimple
            allValues={kategorijeAll}
            selectedValue={obrazac.kategorija}
            onSelectChange={(v) => handleChange(v, "kategorija")}
          />
        </div>

        <div style={{ width: "15vw" }}>
          <div style={natpis}>ВРСТА МАШИНЕ</div>
          <CustomSelectSimple
            allValues={
              obrazac.kategorija ? masinePoKategoriji[obrazac.kategorija] : []
            }
            selectedValue={obrazac.vrstaMasine}
            onSelectChange={(v) => handleChange(v, "vrstaMasine")}
          />
        </div>

        <div style={{ width: "12vw" }}>
          <div style={natpis}>БРОЈ НАЛАЗА</div>
          <input
            value={obrazac.broj_nalaza}
            onChange={(e) => handleChange(e.target.value, "broj_nalaza")}
            style={inputStyle}
          />
        </div>

        <div>
          <div style={natpis}>ДАТУМ ПРЕГЛЕДА</div>
          <CustomCalendarInput
            value={obrazac.datum_pregleda}
            onChange={(v) => handleChange(v, "datum_pregleda")}
          />
        </div>

        <div style={{ flex: 1 }}>
          <div style={natpis}>НАПОМЕНА</div>
          <input
            value={obrazac.napomena}
            onChange={(e) => handleChange(e.target.value, "napomena")}
            style={inputStyle}
          />
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <div onClick={() => setIsDodavanje(false)}>
            <Button activation={true} style={styles.button}>
              ОДУСТАНИ
            </Button>
          </div>
          <div
            onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
            style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}
          >
            <Button
              isDisabled={isDisabledSacuvaj}
              activation={true}
              style={styles.button}
            >
              САЧУВАЈ
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EvidencijeObrazac8Dodavanje;
